import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSendPasswordResetEmail } from "react-firebase-hooks/auth";
import { AuthError } from "firebase/auth";
import { firebaseAuth } from "../../firebaseConfig";
import { PasswordResetForm } from "@components";
import { useNavigate } from "react-router-dom";
import { ValidationError } from "../../types/ValidationError";

const authSuccess: ValidationError = { isError: false };

export const PasswordResetPage: FC = () => {
  const [sendPasswordResetEmail, sending, error] =
    useSendPasswordResetEmail(firebaseAuth);

  const [errors, setErrors] = useState(authSuccess);
  const navigate = useNavigate();
  const { t } = useTranslation("common");

  useEffect(() => {
    if (error) {
      var authResult: ValidationError = {
        isError: true,
        errorFields: [],
        errorMessage: t("errors.password_reset_failure"),
      };
      const errorCode = (error as AuthError).code;
      if (
        errorCode === "auth/invalid-email" ||
        errorCode === "auth/missing-email"
      ) {
        authResult.errorFields = ["email"];
        authResult.errorMessage = t("errors.email_invalid");
      }
      setErrors(authResult);
    }
  }, [error, t]);

  const actionCodeSettings = {
    url: window.location.origin + "/login",
  };

  return (
    <div className="bg-surface-muted w-screen h-screen">
      <PasswordResetForm
        onClickPasswordReset={async (email) => {
          const success = await sendPasswordResetEmail(
            email,
            actionCodeSettings,
          );
          if (success) {
            navigate("/login", {
              state: { info: t("password_reset_email_sent") },
            });
          }
        }}
        validation={errors}
        isProcessing={sending}
      />
    </div>
  );
};
